type CalculateTotalPriceParams = {
    count: number;
    price: number;
    quantityPerBox?: number | null;
    pricePerBox?: number | null;
};

export const calculateTotalPrice = ({
        count,
        price,
        quantityPerBox,
        pricePerBox,
    }: CalculateTotalPriceParams): number => {
    if (!quantityPerBox || !pricePerBox) {
        return count * price;
    }

    const numberOfBoxes = Math.floor(count / quantityPerBox);
    const remainingItems = count % quantityPerBox;

    return (
        numberOfBoxes * quantityPerBox * pricePerBox +
        remainingItems * price
    );
};
